<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col">
        <h1 class="text-center py-4">Categorias</h1>
        <div class="container">
          <table class="table">
            <thead class="thead-dark text-center">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Categoria</th>
                <th scope="col">CRR</th>
                <th scope="col">Tipo</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr v-for="(category, index) in categories" :key="category._id">
                <td>{{ index + 1 }}</td>
                <td>{{ category.name }}</td>
                <td>{{ category.crr }}%</td>
                <td scope="col">
                  <span
                    class="badge"
                    :class="
                      category.kind == 'producto'
                        ? 'badge-info'
                        : 'badge-primary'
                    "
                    >{{ category.kind }}</span
                  >
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'Category',
                      params: {
                        id: category._id,
                        title: category.name.replace(/\s/g, '-'),
                      },
                    }"
                  >
                    <span class="material-icons text-info">settings</span>
                  </router-link>
                  <span
                    class="material-icons text-danger cursor-pointer"
                    @click="handleDeleteCategory(category._id)"
                    >delete_outline</span
                  >
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="row mx-4">
                    <div class="col">
                      <input
                        placeholder="Nombre de la nueva categoria"
                        type="text"
                        class="form-control"
                        v-model="newCategory"
                      />
                    </div>
                    <div class="col-auto">
                      <input
                        placeholder="% CRR"
                        type="number"
                        class="form-control"
                        v-model="newCategoryCrr"
                      />
                    </div>
                    <div class="col-auto">
                      <select class="form-control" v-model="newCategoryKind">
                        <option>producto</option>
                        <option>servicio</option>
                      </select>
                    </div>
                    <div class="col-auto">
                      <span
                        class="btn btn-primary mb-2"
                        @click="handleAddCategory()"
                        >Agregar</span
                      >
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import Api from "../../tools/Api2";
import { mapState } from "vuex";

export default {
  name: "Categories",
  data() {
    return {
      categories: [],
      newCategory: "",
      newCategoryKind: "producto",
      newCategoryCrr: "",
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    reloadCategories() {
      Api("category")
        .get()
        .then((res) => {
          this.categories = res.categories;
        });
    },
    handleDeleteCategory(id) {
      Api("category")
        .delete(id)
        .then(() => this.reloadCategories());
    },
    handleAddCategory() {
      Api("category")
        .post({
          name: this.newCategory,
          kind: this.newCategoryKind,
          crr: Number(this.newCategoryCrr),
        })
        .then(() => {
          this.newCategory = "";
          this.newCategoryCrr = "";
          this.reloadCategories();
        });
    },
  },
  components: {
    NavbarMain,
    NavbarAdmin,
  },
  created: function () {
    this.reloadCategories();
  },
};
</script>
